import { LocationData } from "./locationData";

export class Broker {
  firstName!: string;
  lastName!: string;
  phone!: string;
  email!: string;
  locationAddress!: LocationData;

  constructor(data?: any) {
    if (data) {
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.phone = data.phone;
      this.email = data.email;
      this.locationAddress = new LocationData(data.locationAddress);
    }
  }
}